import {
	type BackendPlacementMessage,
	defaultMessageBackend,
	type FrontendPlacementMessage,
	type FrontendStage,
	noValidation,
} from '@post-office/placement-common-v2';
import {
	PlacementBackend,
	PlacementFrontend,
} from '@post-office/placements--jsm-sequoia/jira-navbar-assets-app-section';

import { type PlacementRenderProps } from '@post-office/placements--jsm-sequoia/jira-navbar-assets-app-section';
import type { MessageTemplateContext } from '../../..';
import { AssetsPremiumTrialItem } from '../../../components/assets-premium-trial-item';
import {
	type CreatePlacementMessageConfig,
	type BackendSyncMessageStage,
	type AnyPayload,
	type AnyBackendMessageStage,
} from '@post-office/placement-common-v2/create-placement/types';
import { type TransformMetadataResult } from '@post-office/shared-contracts/message-template-metadata';

type MessageFrontendProps = MessageTemplateContext & PlacementRenderProps;

export const MessageBackend: (config: CreatePlacementMessageConfig) => BackendPlacementMessage<{
	transformMetadata: BackendSyncMessageStage<AnyPayload, TransformMetadataResult>;
	hydrate?: AnyBackendMessageStage;
}> = PlacementBackend.createMessageBackend(defaultMessageBackend);

export const MessageFrontend: (config: CreatePlacementMessageConfig) => FrontendPlacementMessage<{
	render: FrontendStage<PlacementRenderProps>;
}> = PlacementFrontend.createMessageFrontend({
	render: {
		validate: noValidation<MessageFrontendProps>(),
		Component: ({ dismiss, onItemClick, onItemViewed }: MessageFrontendProps) => (
			<AssetsPremiumTrialItem
				dismiss={dismiss}
				onItemClick={onItemClick}
				onItemViewed={onItemViewed}
			/>
		),
	},
});
